import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Konversi IPK ke Sistem Penilaian Malaysia";
const DESCRIPTION =
  "Temukan cara mengkonversi IPK Anda ke sistem Malaysia dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Malaysia.";
const KEYWORDS =
  "sistem universitas Malaysia, konversi IPK universitas, sistem nilai Malaysia, nilai sarjana, nilai magister, IPK universitas, Malaysia";
const OG_URL = "https://do-calculate.com/calculator/id/gradetomalaysia";
function GpaToMalaysia() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const percentageToGpa = (percentage) => {
    if (percentage >= 93 && percentage <= 96) {
      return 4.0;
    } else if (percentage >= 90 && percentage <= 92) {
      return 3.67;
    } else if (percentage >= 87 && percentage <= 89) {
      return 3.33;
    } else if (percentage >= 83 && percentage <= 86) {
      return 3.0;
    } else if (percentage >= 80 && percentage <= 82) {
      return 2.67;
    } else if (percentage >= 77 && percentage <= 79) {
      return 2.33;
    } else if (percentage >= 73 && percentage <= 76) {
      return 2.0;
    } else if (percentage >= 70 && percentage <= 72) {
      return 1.67;
    } else if (percentage >= 67 && percentage <= 69) {
      return 1.33;
    } else if (percentage >= 65 && percentage <= 66) {
      return 1.0;
    } else if (percentage >= 0 && percentage <= 64) {
      return 0.0;
    } else {
      return "Input tidak valid";
    }
  };
  const gpaToMalaysianGrade = (gpa) => {
    if (gpa === 4.0) {
      return "A";
    } else if (gpa === 3.67) {
      return "A-";
    } else if (gpa === 3.33) {
      return "B+";
    } else if (gpa === 3.0) {
      return "B";
    } else if (gpa === 2.67) {
      return "B-";
    } else if (gpa === 2.33) {
      return "C+";
    } else if (gpa === 2.0) {
      return "C";
    } else if (gpa === 1.67) {
      return "C-";
    } else if (gpa === 1.33) {
      return "D+";
    } else if (gpa === 1.0) {
      return "D";
    } else if (gpa === 0.0) {
      return "F";
    } else {
      return "Input tidak valid";
    }
  };
  const calculateConversion = (value) => {
    if (conversionType === "grade") {
      const percentage = parseFloat(value);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
        const gpa = percentageToGpa(percentage);
        return gpaToMalaysianGrade(gpa);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToMalaysianGrade(gpa);
      }
    }
    return "Input tidak valid";
  };
  const handleCalculateClick = () => {
    const converted = calculateConversion(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
              </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Temukan cara mengkonversi IPK Anda (persentase atau IPK) ke sistem Malaysia dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Malaysia menggunakan alat yang berguna ini.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Konversi IPK Universitas ke Sistem Malaysia
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>Jenis Nilai:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      Persentase (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      IPK (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="originalValue">
                      {conversionType === "grade"
                        ? "Nilai Persentase:"
                        : "IPK:"}
                    </label>
                  </b>
                  <input
                    type="text"
                    value={originalValue}
                    id="originalValue"
                    onChange={(e) => setOriginalValue(e.target.value)}
                    className="form-control"
                    style={{ width: "200px", marginRight: "4px" }}
                  />
                  <button
                    className="btn btn-success mt-2"
                    onClick={handleCalculateClick}
                  >
                    Hitung
                  </button>
                </div>
                {error && (
                  <div className="alert alert-danger mt-2">
                    <b>
                      <u>Kesalahan:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark mt-3 p-2"
                  >
                    <div className="p-2 bg-success bg-gradient text-white">
                      <strong>Hasil:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `Nilai dalam Sistem Malaysia: ${convertedValue}`
                        : `Nilai Malaysia untuk IPK: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Sistem Klasifikasi Nilai Universitas di Malaysia
                    </h2>
                  </u>
                  <p>
                    Di Malaysia, nilai universitas diklasifikasikan pada skala dari A hingga F, dengan A adalah yang terbaik dan F adalah yang terburuk. Nilai dapat dibagi sebagai berikut:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>Nilai U.S. (dari 100)</th>
                        <th>Persentase Setara</th>
                        <th>Nilai IPK</th>
                        <th>Nilai Malaysia</th>
                       </tr>
                    </thead>
                    <tbody>
                       <tr>
                         <td>A</td>
                         <td>93-96%</td>
                         <td>4.0</td>
                         <td>A</td>
                       </tr>
                       <tr>
                         <td>A-</td>
                         <td>90-92%</td>
                         <td>3.67</td>
                         <td>A-</td>
                       </tr>
                       <tr>
                         <td>B+</td>
                         <td>87-89%</td>
                         <td>3.33</td>
                         <td>B+</td>
                       </tr>
                       <tr>
                         <td>B</td>
                         <td>83-86%</td>
                         <td>3.00</td>
                         <td>B</td>
                       </tr>
                       <tr>
                         <td>B-</td>
                         <td>80-82%</td>
                         <td>2.67</td>
                         <td>B-</td>
                       </tr>
                       <tr>
                         <td>C+</td>
                         <td>77-79%</td>
                         <td>2.33</td>
                         <td>C+</td>
                       </tr>
                       <tr>
                         <td>C</td>
                         <td>73-76%</td>
                         <td>2.00</td>
                         <td>C</td>
                       </tr>
                       <tr>
                         <td>C-</td>
                         <td>70-72%</td>
                         <td>1.67</td>
                         <td>C-</td>
                       </tr>
                       <tr>
                         <td>D+</td>
                         <td>67-69%</td>
                         <td>1.33</td>
                         <td>D+</td>
                       </tr>
                       <tr>
                         <td>D</td>
                         <td>65-66%</td>
                         <td>1.00</td>
                         <td>D</td>
                       </tr>
                       <tr>
                         <td>F</td>
                         <td>0-64%</td>
                         <td>0.0</td>
                         <td>F</td>
                       </tr>
                    </tbody>
                  </table>
                  <p>
                    Informasi ini membantu memahami cara mengkonversi nilai ke sistem Malaysia dan mengetahui persentase setaranya.
                  </p>
                  <b className="text-primary">
                    <span>Contoh: </span>
                    Jika Anda memiliki IPK 3.0 pada skala 4.0, Anda dapat mengkonversinya ke sistem Malaysia menggunakan alat di atas dan Anda akan mendapatkan hasil yang setara.
                  </b>
                  <p>
                    Alat ini sangat berguna bagi mahasiswa internasional yang ingin melanjutkan studi di Malaysia atau melamar pekerjaan yang membutuhkan IPK tertentu.
                  </p>
                  <div>
                    <p>
                      Malaysia adalah negara yang maju secara ilmiah, dengan banyak universitas ternama yang menjadi tujuan mahasiswa dari seluruh dunia.
                    </p>
                    <p className="alert alert-info">
                      Di Malaysia terdapat banyak universitas yang terakreditasi secara global, dan sistem studi di universitas Malaysia dikenal dengan ketelitian ilmiah dan kebaruan kurikulum. Biaya studi di Malaysia juga relatif terjangkau dibandingkan dengan negara-negara Eropa lainnya dan Amerika Serikat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GpaToMalaysia;